import { CSSProperties, ReactNode } from 'react';
// form
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  onKeyDown?: React.KeyboardEventHandler<HTMLFormElement>;
  isLoginForm?: boolean;
  formId?: string;
  sx?: CSSProperties;
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  isLoginForm,
  formId,
  onKeyDown,
  sx,
}: Props) {
  const { REACT_APP_API_URL } = process.env;
  return (
    <Form {...methods}>
      {isLoginForm ? (
        <form action={`${REACT_APP_API_URL}/loginProcess`} method="POST" onKeyDown={onKeyDown}>
          {children}
        </form>
      ) : (
        <form onSubmit={onSubmit} style={sx} id={formId} onKeyDown={onKeyDown}>
          {children}
        </form>
      )}
    </Form>
  );
}
